/* eslint-disable @typescript-eslint/no-explicit-any */
import classes from './CellProductionsStartMintActions.module.css';
import { Box, rem, Image } from '@mantine/core';
import { ActionIcon } from '@mantine/core';
import IconViewMore from '@assets/icons/view-more.svg';
import IconClose from '@assets/icons/close.svg';

export const CellProductionsStartMintActions = (props: {
	onViewMore?: (data: any) => void;
	onDelete?: (data: any) => void;
	row?: any;
}) => {
	return (
		<Box
			style={{
				display: 'flex',
			}}
		>
			<ActionIcon
				data-testid="W2FtPXR1_Z5jdHi6B-menu"
				variant="transparent"
				className={classes.customSize}
				onClick={(event) => {
					event.stopPropagation();
					if (props && props.row) {
						props.onViewMore!(props.row);
					}
				}}
			>
				<Image
					style={{
						objectFit: 'contain',
						width: rem(22),
						height: rem(22),
					}}
					src={IconViewMore}
				/>
			</ActionIcon>
			<ActionIcon
				data-testid="W2FtPXR2_Z5jdHi6B-menu"
				variant="transparent"
				className={classes.customSize}
				onClick={(event) => {
					event.stopPropagation();
					if (props && props.row) {
						props.onDelete!(props.row);
					}
				}}
			>
				<Image
					style={{
						objectFit: 'contain',
						width: rem(20),
						height: rem(20),
					}}
					src={IconClose}
				/>
			</ActionIcon>
		</Box>
	);
};
